/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Confirm_Cancel_InInputs */

const vi_sl_detail_confirm_cancel_in = /** @type {(inputs: Sl_Detail_Confirm_Cancel_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy phiếu nhập này?`)
};

/**

* @param {Sl_Detail_Confirm_Cancel_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_confirm_cancel_in = /** @type {((inputs?: Sl_Detail_Confirm_Cancel_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Confirm_Cancel_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_confirm_cancel_in(inputs)
});